import { segmentsQueryKeys } from "./queryKeys";

import type { ClientRealtimeFeature } from "@/features/realtime";
import { SEGMENT_REALTIME_EVENTS } from "@/features/segments/constants";
import type { SegmentRealtimeEvent } from "@/features/segments/types";

/**
 * Queries invalidated here opt into `refetchOnMount: true` (refetch only if stale), so one invalidated while
 * its page is closed refetches when the page opens again instead of serving the app default's stale cache.
 */
export const segmentsRealtime: ClientRealtimeFeature = {
  events: {
    [SEGMENT_REALTIME_EVENTS]: async (queryClient, payload) => {
      const { segmentId } = payload as SegmentRealtimeEvent;
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.segment(segmentId) }),
        queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.historyOf(segmentId) }),
        queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.lists() }),
      ]);
    },
  },
  resetKey: segmentsQueryKeys.all,
};